import { render, staticRenderFns } from "./SupplementSearchField.vue?vue&type=template&id=1e2ba11c&scoped=true"
import script from "./SupplementSearchField.vue?vue&type=script&lang=js"
export * from "./SupplementSearchField.vue?vue&type=script&lang=js"
import style0 from "./SupplementSearchField.vue?vue&type=style&index=0&id=1e2ba11c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e2ba11c",
  null
  
)

export default component.exports